export const ROLE = {
  admin: 1,
  customer: 2,
  partner: 3,
  seller: 4,
};
